import axios from 'axios';
import { apiEndpoint } from '@/enums/generic';
import { Order } from '@/models/Order';
import { OrderStatus } from '@/models/types/OrderStatus';
import { plainToInstance } from 'class-transformer';
import { Compatibility } from '@/models/Compatibility';

const ordersUrl = apiEndpoint.assignedOrdersUrl;
const statusOrderUrl = apiEndpoint.statusOrderUrl;

export const fetchAllAssignedOrders = async function (): Promise<Array<Order>> {
  const { data } = await axios.get<Order[]>(`${ordersUrl}`);
  return data.map((order) => {
    return plainToInstance(Order, order);
  });
};

export const fetchOrderById = async function (id: string): Promise<Order> {
  const { data } = await axios.get<Order>(`${statusOrderUrl}/${id}`);
  return plainToInstance(Order, data);
};

export const saveOrderStatus = async function (
  id: string,
  statusValue: OrderStatus
): Promise<void> {
  const status = { status: statusValue };
  await axios({
    method: 'PUT',
    url: `${statusOrderUrl}/${id}/status`,
    data: status,
  });
};

export const startOrder = async function (id: string): Promise<Order> {
  const { data } = await axios({
    method: 'POST',
    url: `${statusOrderUrl}/${id}/start`,
  });

  return plainToInstance(Order, data);
};

export const putOrderDetails = async function (
  orderId: string,
  noteValue?: string,
  propertyCompatibility?: Compatibility
): Promise<void> {
  const details = {
    note: noteValue,
    propertyCompatibility: propertyCompatibility,
  };
  await axios({
    method: 'PUT',
    url: `${statusOrderUrl}/${orderId}/details`,
    data: details,
  });
};

export const putOrderProgress = async function (selectedOrder: Order) {
  const progress = { changes: selectedOrder.changes };
  await axios({
    method: 'PUT',
    url: `${statusOrderUrl}/${selectedOrder.id}/progress`,
    data: progress,
  });
};
